import React from 'react';

import * as DateHelpers from 'helpers/dateHelpers';
import styles from './clientUserTimezonesDate.module.scss';

export const ClientUserTimezonesDate = ({ date, timezone }: { date: string; timezone: string }) => (
  <>
    <div className={styles.userTimezone}>{DateHelpers.readableDateFormat(date, DateHelpers.getUserTimezone())}</div>

    {DateHelpers.isDifferentTimezone(date, timezone) && (
      <div className={styles.clientTimezone}>{DateHelpers.readableDateFormat(date, timezone)}</div>
    )}
  </>
);
